import { render } from "./Clerk2.vue?vue&type=template&id=056bb709&scoped=true"
import script from "./Clerk2.vue?vue&type=script&lang=js"
export * from "./Clerk2.vue?vue&type=script&lang=js"

import "./Clerk2.vue?vue&type=style&index=0&id=056bb709&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bmark-kid/bmark-kid-manage-html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056bb709"]])

export default __exports__